// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__Ke","cls2":"CreateSocialItemModal-cls2_H_l CreateSocialItemModal-cls1__Ke"};